import { useCallback, useEffect, useRef, useState } from 'react';
import { initializePaddle, Paddle } from '@paddle/paddle-js';
import useBillingType from '../account/UseBillingType';
import { REACT_APP_PROD_PADDLE, REACT_APP_TEST_PADDLE } from '../../utils/config';

const usePaddle = (onCheckoutCompleted?: () => void) => {
  const isProdBilling = useBillingType();
  const [paddle, setPaddle] = useState<Paddle>();
  // Keep the latest callback in a ref so initializePaddle doesn't need to re-run.
  const onCheckoutCompletedRef = useRef(onCheckoutCompleted);
  onCheckoutCompletedRef.current = onCheckoutCompleted;

  const initPaddle = useCallback(async () => {
    const environment = isProdBilling ? 'production' : 'sandbox';
    const token = isProdBilling ? REACT_APP_PROD_PADDLE : REACT_APP_TEST_PADDLE;

    initializePaddle({
      environment,
      token: token || '',
      eventCallback: (event) => {
        if (event?.name === 'checkout.completed') {
          onCheckoutCompletedRef.current?.();
        }
      },
    }).then((paddleInstance: Paddle | undefined) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, []);

  useEffect(() => {
    initPaddle();
  }, [initPaddle]);

  return { paddle, initPaddle };
};

export default usePaddle;
